const getters = {
    sidebar: (state) => state.app.sidebar,
    breadCrumbList: (state) => state.app.breadCrumbList,
    userInfo:(state) => state.user.userInfo,
    skinMode:(state) => state.app.skinMode,
    settingInfo:(state) => state.app.settingInfo,
    pageTitle:(state) => state.app.pageTitle,
    mapToken:(state)=> state.app.mapToken,
    tempQuery:(state)=> state.app.tempQuery,
};
export default getters;
